import { render, staticRenderFns } from "./PrestadoresDetalhe.vue?vue&type=template&id=43ebe218"
import script from "./PrestadoresDetalhe.vue?vue&type=script&lang=js"
export * from "./PrestadoresDetalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports